<template>
  <div class="view box grow" style="overflow-y: auto">
    <page-headers
      :header="'Hosts'"
      :breadcrumbs="breadcrumbs"
      :is-border="true"
      :documentation="'page-hosts'"
      class="box"
    >
    </page-headers>
    <div class="full-height" v-loading="accountKeyAgentListReqStatus === 'loading'">
      <el-row type="flex" class="account-summary__row" :gutter="20" v-if="accountKeyAgentListReqStatus === 'saved'">
        <el-col :span="4">
          <div class="display-inline-block absolute-pos">
            <span class="display-block title">VMs </span>
            <span class="display-block count"
              >{{ accountKeyActiveAgentSummary.assetCount || 0 }}
              <!-- <i class="fal fa-exclamation-triangle" v-if="accountKeyActiveAgentSummary.unprotectedCount > 0"></i> -->
            </span>
            <el-dropdown placement="bottom-start" v-if="$allow('network', 'write')">
              <div class="drop-down-title">
                <span class="display-inline-block">add VMs</span>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'aws' } }">
                    <a class="display-inline-block">Amazon Web Services</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'azure' } }">
                    <a class="display-inline-block">Microsoft Azure</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'gcp' } }">
                    <a class="display-inline-block">Google Cloud</a>
                  </router-link>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-col>
        <el-col :span="4">
          <el-divider direction="vertical"></el-divider>
          <div class="display-inline-block absolute-pos">
            <span class="display-block title">UNPROTECTED</span>
            <span class="display-block count">{{ accountKeyActiveAgentSummary.unprotectedCount || 0 }}</span>
            <router-link v-if="$allow('network', 'write')" :to="{ name: 'installation' }">
              <a class="display-inline-block">install agents</a>
            </router-link>
            <br v-else />
          </div>
        </el-col>
        <el-col :span="4">
          <el-divider direction="vertical"></el-divider>
          <div class="display-inline-block">
            <span class="display-block title">UPDATE</span>
            <span class="display-block count">{{ accountKeyActiveAgentSummary.upgradeableCount || 0 }}</span>
            <router-link v-if="$allow('network', 'write')" :to="{ name: 'installation' }">
              <a class="display-inline-block">update agents</a>
            </router-link>
            <br v-else />
          </div>
        </el-col>
        <el-col :span="4">
          <el-divider direction="vertical"></el-divider>
          <div class="display-inline-block absolute-pos">
            <span class="display-block title">NEEDS ATTENTION</span>
            <span class="display-block count">{{ accountKeyActiveAgentSummary.needsAttentionCount || 0 }}</span>
            <span class="text-btn" @click="loadDocumentation('page-hosts')">Learn More</span>
          </div>
        </el-col>
        <el-col :span="4">
          <el-divider direction="vertical"></el-divider>
          <div class="display-inline-block absolute-pos">
            <span class="display-block title">PROGRESSIONS</span>
            <span class="display-block count">{{ accountKeyActiveAgentSummary.progressionCount || 0 }}</span>
            <router-link :to="{ name: 'active-cyber-attacks' }"
              ><a class="display-inline-block">investigate</a>
            </router-link>
          </div>
        </el-col>
        <el-col :span="4">
          <el-divider direction="vertical"></el-divider>
          <div class="display-inline-block absolute-pos">
            <span class="display-block title">EXPOSED</span>
            <span class="display-block count">{{ accountKeyActiveAgentSummary.exposedAgents.length || 0 }}</span>
            <div @click="openExposedDialogVisible = true"><a class="display-inline-block">see more</a></div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="float-right info-buttons flex-dis">
            <el-button class="help-button" size="small" style="background: white">
              <el-link @click="loadDocumentation('page-hosts')" :underline="false">
                User Guide
              </el-link>
            </el-button>
            <el-dropdown class="ml-21" v-if="$allow('network', 'write')">
              <span class="el-dropdown-link">
                <el-button class="add-button" size="small">
                  Add VMs
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'aws' } }">
                    <a class="display-inline-block">Amazon Web Services</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'azure' } }">
                    <a class="display-inline-block">Microsoft Azure</a>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'gcp' } }">
                    <a class="display-inline-block">Google Cloud</a>
                  </router-link>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-col>
      </el-row>

      <div class="table-toolbar" v-if="accountKeyAgentListReqStatus === 'saved'">
        <table-toolbar
          ref="hostTableToolbar"
          v-if="apiCalled"
          :key="accountKeyActiveAgentList.key"
          :search-properties="visibleHostsColumns"
          :total-search-properties="hostsColumns"
          :search-data="accountKeyActiveAgentList"
          :initial-tags="accountKeyActiveAgentList.searchTags"
          :active-filter-data="activeFiltersData"
          :reload-component="accountKeyActiveAgentList.reloadToolbar"
          @update-querydata="updateTableQueryData"
          @refresh-tabledata="refreshTableData"
          @update-columns-data="modifyColumnsData"
          @add-searchtags="addSearchTags"
          @deactivate-filter="deactivateFilter"
        >
          <div slot="local-helper" class="search-reset">
            <div class="grid-content helper-message">
              <p v-if="$route.query.accountKey">
                Showing VMs for {{ $route.query.nickName || $route.query.accountKey }}
              </p>
              <p v-else>Showing VMs for Integration Accounts</p>
              <el-button type="text" class="icon-text-button" @click="gotoParentPage">
                <i class="material-icons c-icon"></i><span>Reset</span>
              </el-button>
            </div>
          </div>
          <div slot="left-toolbar-tools" class="filter-button-group">
            <el-button
              size="small"
              round
              :class="{ active: hostFiltersSelected.includes('all') }"
              @click.native="changeFilterSelection('all')"
            >
              All
            </el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button
              size="small"
              round
              :class="{ active: hostFiltersSelected.includes('aws') }"
              @click.native="changeFilterSelection('aws')"
            >
              AWS Hosts
            </el-button>
            <el-button
              size="small"
              round
              :class="{ active: hostFiltersSelected.includes('azure') }"
              @click.native="changeFilterSelection('azure')"
            >
              Azure Hosts
            </el-button>
            <el-button
              size="small"
              round
              :class="{ active: hostFiltersSelected.includes('gcp') }"
              @click.native="changeFilterSelection('gcp')"
            >
              GCP Hosts
            </el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button
              size="small"
              round
              :class="{ active: filtersSelected.includes('protected') }"
              @click.native="changeFilterSelection('protected')"
            >
              Protected
            </el-button>
            <el-button
              size="small"
              round
              :class="{ active: filtersSelected.includes('atrisk') }"
              @click.native="changeFilterSelection('atrisk')"
            >
              At Risk
            </el-button>
            <!-- <el-button
              size="small"
              round
              :class="{ active: filtersSelected.includes('pinned') }"
              @click.native="changeFilterSelection('pinned')"
            >
              Pinned
            </el-button> -->
            <!-- <el-button size="small" round>
              More Filters
            </el-button> -->
            <el-divider direction="vertical"></el-divider>
            <span v-if="filterList.length">
              <div class="display-inline mr-18  relative-pos" v-for="(btn, index) in filterList" :key="index">
                <el-input
                  ref="customFilterInput"
                  class="filter-input"
                  v-if="btn.editFlag"
                  placeholder="+Name"
                  v-model="btn.name"
                  @change.native.stop="handleFilterNameChange(btn)"
                  @keyup.native.enter="handleFilterNameChange(btn)"
                  @blur="handleFilterNameChange(btn)"
                ></el-input>
                <el-button
                  v-else
                  size="small"
                  round
                  :class="{ active: btn.active }"
                  :id="btn.id"
                  @click="changeState(btn)"
                >
                  {{ btn.name }}
                  <i class="el-icon-edit el-icon--right" @click.stop="editFilter(btn)"></i>
                  <i class="el-icon-close el-icon--right" @click.stop="removeBtnFromList(btn, index)"></i>
                </el-button>

                <span v-if="btn.errFlag" class="filter-name-validator">{{ filterErrMsg }}</span>
              </div>
            </span>
          </div>
          <div slot="local-actions">
            <el-button-group class="localaction-button-group">
              <el-tooltip class="item" effect="dark" content="Add Location Tag" placement="top" :enterable="false">
                <el-button
                  v-if="$allow('agents', 'write')"
                  type="text"
                  :disabled="!displayTableActions.locationTagEnabled"
                  class="cursor-pointer"
                  :class="{
                    'display-none': !displayTableActions.show && !displayTableActions.multiselect,
                    disabled: !displayTableActions.locationTagEnabled
                  }"
                  @click="openAddLocationDialog()"
                >
                  <i class="material-icons c-icon">add_location_alt</i>
                </el-button>
              </el-tooltip>

              <el-tooltip class="item" effect="dark" content="Decommission Host" placement="top" :enterable="false">
                <el-button
                  v-if="$allow('agents', 'write')"
                  type="text"
                  class="cursor-pointer"
                  :class="{
                    'display-none': !displayTableActions.show && !displayTableActions.multiselect,
                    disabled: !displayTableActions.decommissionEnabled
                  }"
                  @click="openDecommissionDialog()"
                >
                  <i class="material-icons c-icon">power_off</i>
                </el-button>
              </el-tooltip>

              <el-tooltip class="item" effect="dark" content="Rename Host" placement="top" :enterable="false">
                <el-button
                  v-if="$allow('agents', 'write')"
                  type="text"
                  class="cursor-pointer"
                  :class="{
                    'display-none': !displayTableActions.show && !displayTableActions.singleselect,
                    disabled: displayTableActions.multiselect
                  }"
                  @click="openCustomHostname()"
                >
                  <i class="material-icons c-icon">create</i>
                </el-button>
              </el-tooltip>

              <el-tooltip class="item" effect="dark" content="Edit Criticality" placement="top" :enterable="false">
                <el-button
                  v-if="$allow('agents', 'write')"
                  type="text"
                  class="cursor-pointer"
                  :class="{ 'display-none': !displayTableActions.show && !displayTableActions.multiselect }"
                  @click="openCriticalityDialog()"
                >
                  <i class="material-icons c-icon">priority_high</i>
                </el-button>
              </el-tooltip>

              <el-tooltip class="item" effect="dark" content="Host Details" placement="top" :enterable="false">
                <el-button
                  type="text"
                  class="cursor-pointer"
                  :class="{
                    'display-none': !displayTableActions.show && !displayTableActions.singleSelect,
                    disabled: displayTableActions.multiselect
                  }"
                  @click="openDetails"
                >
                  <i class="material-icons c-icon">info</i>
                </el-button>
              </el-tooltip>
            </el-button-group>
          </div>
        </table-toolbar>
      </div>

      <expandable-multi-select-table-element
        class="host-table"
        v-if="accountKeyAgentListReqStatus === 'saved' && apiCalled"
        ref="agentTable"
        :columns="visibleHostsColumns"
        :table-data="accountKeyActiveAgentList"
        :height-offset="40"
        @update-record-count="recordCountHandler"
        @table-selection-change="checkTableSelectionChanges"
      ></expandable-multi-select-table-element>
    </div>

    <aside-sidebar
      parent=".layout-container"
      sibling=".host-table"
      v-model="hideHostDetails"
      v-if="accountKeyAgentListReqStatus == 'saved'"
    >
      <div slot="title">
        <h2 class="mv-0">{{ agentSelected.customHostname || agentSelected.agentId }}</h2>
      </div>
      <host-details-feed slot="content" :host-details="agentSelected"></host-details-feed>
    </aside-sidebar>

    <el-dialog title="Decommission Agents" :visible.sync="openDecommissionDialogVisible">
      <el-form :model="decommissionHostsSelection" ref="decommissionHostsForm">
        <div>
          <label>
            Are you sure you want to decommission agents for the selected hosts? Once decommissioned, the hosts will no
            longer show up in the list.
          </label>

          <h6><br />Hosts selected:</h6>
          <span v-for="(agent, idx) in decommissionHostsSelection.agents" :key="idx">
            {{ agent.getAgentLabel() }}
            <el-divider v-if="idx !== decommissionHostsSelection.agents.length - 1" direction="vertical"></el-divider>
          </span>
        </div>
        <div v-if="decommissionHostsSelection.error" class="error">
          <label>{{ decommissionHostsSelection.error }}</label>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="openDecommissionDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="decommissionHosts(decommissionHostsSelection.agents)">Decommission</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Rename Host" :visible.sync="openCustomHostnameDialogVisible">
      <el-form :model="agentSelected" ref="renameHostRef" :rules="customHostnameRules">
        <el-form-item label="Rename Host" prop="customHostname">
          <el-input placeholder="Create custom Hostname" v-model.trim="agentSelected.customHostname"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="openCustomHostnameDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="createCustomHostname(agentSelected)">Confirm</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="openLocationPopUp" title="Location Tags" width="60%" @close="resetLocationTagState">
      <el-form :model="locationTag" ref="locationTagRef" :rules="locationTagRules">
        <div style="display: flex">
          <el-form-item class="mr-68" label="Create New" prop="name">
            <el-input v-model="locationTag.name" placeholder="Enter name"></el-input>
            <el-button type="primary" class="create-location-tag" round @click="createLocationTag()">
              Create Tag
            </el-button>
          </el-form-item>
          <el-form-item label="Add Location Tag to your Confluera Assets">
            <div class="empty-location-tag-container" v-if="!locationTags.length">
              <span>New Tags will appear here.</span>
            </div>
            <div v-else class="location-tags-container">
              <div v-for="(tag, idx) in locationTags" :key="'tag-' + idx">
                <el-input
                  v-if="tag.editFlag"
                  ref="locationTagInput"
                  class="location-tag-input"
                  placeholder="Enter tag name"
                  v-model="tag.name"
                  @change="handleLocationTagNameChange(tag)"
                  @keyup.native.enter="tag.editFlag = false"
                  @blur="tag.editFlag = false"
                  @focus="onFocus($event)"
                ></el-input>
                <el-button
                  v-else
                  class="location-tag"
                  :id="'tag-' + idx"
                  :class="{ 'active-tag': tag.active }"
                  @click="handleLocationTagClick(idx)"
                >
                  {{ tag.name }}
                </el-button>
              </div>
            </div>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <div class="display-inline-block">
          <div style="display: flex;" :class="{ 'lift-up': removeTagBtnVisible }">
            <div class="location-tag-warning-txt" v-show="removeTagBtnVisible">
              This will remove the selected tag from all assets containing the tag. "Confirm" to delete.
            </div>
            <div class="location-tag-footer-btn-container">
              <el-button
                round
                :class="{ 'disabled-btn': !activeLocationTagsCount }"
                @click="activeLocationTagsCount && (removeTagBtnVisible = !removeTagBtnVisible)"
                style="margin: 0 8px 0 8px;"
              >
                Delete
              </el-button>
              <el-button v-if="removeTagBtnVisible" class="location-tag-txt-btn" @click="deleteLocationTags">
                Confirm
              </el-button>
            </div>
          </div>
        </div>
        <el-button round @click="editTagName" :class="{ 'disabled-btn': activeLocationTagsCount !== 1 }">
          Edit
        </el-button>
        <el-button type="primary" round @click="updateLocationsTags">
          Apply
        </el-button>
      </span>
    </el-dialog>

    <el-dialog title="Edit Criticality for the Selected Host(s)" :visible.sync="openCriticalityDialogVisible">
      <el-form :model="criticalityForm">
        <label class="body1">Select the criticality level</label>
        <el-form-item>
          <el-radio-group v-model="criticalityForm.criticality">
            <el-radio class="display-block" :label="criticalityOptions.CRITICAL">
              <i class="display-inline-block icon icon-criticality-critical" /> {{ criticalityOptions.CRITICAL }}
            </el-radio>
            <el-radio class="display-block" :label="criticalityOptions.IMPORTANT">
              <i class="display-inline-block icon icon-criticality-important" /> {{ criticalityOptions.IMPORTANT }}
            </el-radio>
            <el-radio class="display-block" :label="criticalityOptions.REGULAR">
              <i class="display-inline-block icon icon-criticality-regular" /> {{ criticalityOptions.REGULAR }}
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <p class="body1">This change will be reflected across the application and your organization.</p>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="openCriticalityDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="setCriticalityLevel(rowsSelected, criticalityForm.criticality)"
          >Confirm</el-button
        >
      </span>
    </el-dialog>

    <el-dialog title="Exposed to Public Internet" :visible.sync="openExposedDialogVisible" width="30%">
      <span>
        <span> <b>VMs with exposesd ports to the public : port ranges</b> </span> <br />
        <br />
        <el-table :data="openPublicPorts" height="250">
          <el-table-column property="hostname" label="Name" width="150"></el-table-column>
          <el-table-column property="protocol" label="Protocol" width="80"></el-table-column>
          <el-table-column property="from" label="From" width="80"></el-table-column>
          <el-table-column property="to" label="To" width="80"></el-table-column>
        </el-table>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="openExposedDialogVisible = false">Cancel</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { HostStatusEnum } from '@/constants/host-status.constants'
import { OnOffEnum } from '@/constants/on-off.constants'
import { CriticalityLevelEnum } from '@/constants/criticality.constants'
import { hostsDetailMetaInfo } from '@/column-header/hosts/hosts-details-meta'
import PageHeaders from '@/components/layout/PageHeaders.vue'
import TableToolbar from '@/components/table/TableToolbar.vue'
import ExpandableMultiSelectTableElement from '@/components/table/ExpandableMultiSelectTableElement.vue'
import AsideSidebar from '@/components/layout/AsideSidebar.vue'
import HostDetailsFeed from '@/components/feed/HostDetailsFeed.vue'

import {
  ACCOUNTKEY_AGENT_LIST_REQ,
  CUSTOM_HOSTNAME_REQ,
  BULK_HOSTNAME_REQ,
  DECOMMISSION_AGENTS_REQ
} from '@/store/modules/agents/agents.type'

import {
  VM_VIEW_PREFERENCES_REQ,
  SAVE_VM_VIEW_PREFERENCES
} from '@/store/modules/trails/trailsinfo.type'
import { PREFERENCE_STORE_REQ } from '@/store/modules/column-preference/column-preference.type'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'
import customFilterMixin from '@/mixins/customFilterMixin'
import locationTagMixin from '@/mixins/locationTagMixin'

export default {
  name: 'AccountKeyHosts',
  mixins: [loadDocumentationMixin, customFilterMixin, locationTagMixin],
  data () {
    return {
      tableName: 'VMs',
      vmColumnPrefs: {},
      breadcrumbs: [{ title: 'Asset' }, { title: 'Hosts' }],
      hostsColumns: hostsDetailMetaInfo.meta.columns,
      visibleHostsColumns: [],
      openCustomHostnameDialogVisible: false,
      openCriticalityDialogVisible: false,
      openDecommissionDialogVisible: false,
      openExposedDialogVisible: false,
      hideHostDetails: true,
      displayTableActions: {
        show: false,
        singleSelect: false, // only enabled for 1 row
        multiselect: false, // enabled for 1 or more row,
        locationTagEnabled: false, // enabled if all rows are protected (agent installed)
        decommissionEnabled: false // enabled if all rows are decommissionable (inactive >= 24hrs)
      },
      rowsSelected: {},
      agentSelected: {},
      hostFiltersSelected: ['all'],
      filtersSelected: [],
      changeFilterSelection: {},
      criticalityForm: {},
      apiCalled: false,
      decommissionHostsSelection: {
        agents: [],
        error: ''
      },
      customHostnameRules: {
        customHostname: [
          {
            required: true,
            message: 'Name can not be blank',
            trigger: 'blur'
          }
        ]
      },
      tblId: 1
    }
  },
  methods: {
    gotoParentPage () {
      this.$router.push({ name: 'hosts' })
    },
    filterTableBy (filterField) {
      switch (filterField) {
        case 'all':
          if (!this.hostFiltersSelected.includes('all')) {
            this.hostFiltersSelected.splice(0, 1, 'all')
            this.filtersSelected.length = 0
            this.accountKeyActiveAgentList.resetFilteredObjectAndSearch()
          }
          break
        case 'aws':
          if (!this.hostFiltersSelected.includes('aws')) {
            this.hostFiltersSelected.splice(0, 1, 'aws')
            this.accountKeyActiveAgentList.removeFilteredObject('source', 'AZURE')
            this.accountKeyActiveAgentList.removeFilteredObject('source', 'GCP')
            this.accountKeyActiveAgentList.filterDataByProperty('source', 'AWS')
          }
          break
        case 'azure':
          if (!this.hostFiltersSelected.includes('azure')) {
            this.hostFiltersSelected.splice(0, 1, 'azure')
            this.accountKeyActiveAgentList.removeFilteredObject('source', 'AWS')
            this.accountKeyActiveAgentList.removeFilteredObject('source', 'GCP')
            this.accountKeyActiveAgentList.filterDataByProperty('source', 'AZURE')
          }
          break
        case 'gcp':
          if (!this.hostFiltersSelected.includes('gcp')) {
            this.hostFiltersSelected.splice(0, 1, 'gcp')
            this.accountKeyActiveAgentList.removeFilteredObject('source', 'AWS')
            this.accountKeyActiveAgentList.removeFilteredObject('source', 'AZURE')
            this.accountKeyActiveAgentList.filterDataByProperty('source', 'GCP')
          }
          break
        case 'protected':
          if (!this.filtersSelected.includes('protected')) {
            this.filtersSelected.push('protected')
            this.accountKeyActiveAgentList.filterDataByProperty('protectionOn', 'true')
          } else {
            let found = _.indexOf(this.filtersSelected, 'protected')
            if (found > -1) {
              this.filtersSelected.splice(found, 1)
              this.accountKeyActiveAgentList.removeFilteredObjectAndSearch('protectionOn', 'true')
            }
          }
          break
        case 'atrisk':
          if (!this.filtersSelected.includes('atrisk')) {
            this.filtersSelected.push('atrisk')
            this.accountKeyActiveAgentList.filterDataByProperty('atRisk', 'true')
          } else {
            let found = _.indexOf(this.filtersSelected, 'atrisk')
            if (found > -1) {
              this.filtersSelected.splice(found, 1)
              this.accountKeyActiveAgentList.removeFilteredObjectAndSearch('atRisk', 'true')
            }
          }
          break
        case 'pinned':
          if (!this.filtersSelected.includes('pinned')) {
            this.filtersSelected.splice(0, 1, 'pinned')
          }
          break
      }
      this.updateTableQueryData()
      this.$refs['hostTableToolbar'].setQueryCountText()
    },
    gotoConfigure () {
      this.$router.push({
        name: 'integration-workflow',
        params: { integrationType: 'aws' }
      })
    },
    checkTableSelectionChanges () {
      if (_.isEmpty(this.$refs.agentTable.rowsSelected)) {
        this.displayTableActions.show = false
        this.displayTableActions.singleSelect = false
        this.displayTableActions.multiselect = false
        this.displayTableActions.locationTagEnabled = false
        this.displayTableActions.decommissionEnabled = false
      } else if (this.$refs.agentTable.rowsSelected.length === 1) {
        this.displayTableActions.show = true
        this.displayTableActions.singleSelect = true
        this.displayTableActions.multiselect = false
        this.displayTableActions.decommissionEnabled = this.isHostsDecommissionEligible(
          this.$refs.agentTable.rowsSelected
        )
        this.displayTableActions.locationTagEnabled = this.areSelectedHostsProtected(this.$refs.agentTable.rowsSelected)
      } else {
        this.displayTableActions.show = true
        this.displayTableActions.singleSelect = false
        this.displayTableActions.multiselect = true
        this.displayTableActions.decommissionEnabled = this.isHostsDecommissionEligible(
          this.$refs.agentTable.rowsSelected
        )
        this.displayTableActions.locationTagEnabled = this.areSelectedHostsProtected(this.$refs.agentTable.rowsSelected)
      }
    },
    isHostsDecommissionEligible (hosts) {
      if (
        _.some(this.$refs.agentTable.rowsSelected, {
          decommissionEligibile: false
        })
      ) {
        return false
      }
      return true
    },
    areSelectedHostsProtected (hosts) {
      if (
        _.some(this.$refs.agentTable.rowsSelected, agent => {
          return agent.protected === 'No' || agent.protected === 'Offline'
        })
      ) {
        return false
      }
      return true
    },
    openDecommissionDialog () {
      this.decommissionHostsSelection.error = ''
      this.decommissionHostsSelection.agents.length = 0
      if (
        _.isEmpty(this.$refs.agentTable.rowsSelected) ||
        _.some(this.$refs.agentTable.rowsSelected, {
          decommissionEligibile: false
        })
      ) {
        return false
      }
      this.rowsSelected = _.cloneDeep(this.$refs.agentTable.rowsSelected)
      this.decommissionHostsSelection.agents = this.rowsSelected
      this.openDecommissionDialogVisible = true
    },
    openCustomHostname () {
      if (_.isEmpty(this.$refs.agentTable.rowsSelected) || this.$refs.agentTable.rowsSelected.length > 1) {
        return false
      }
      this.agentSelected = _.cloneDeep(this.$refs.agentTable.rowsSelected[0])
      this.openCustomHostnameDialogVisible = true
    },
    openCriticalityDialog () {
      if (_.isEmpty(this.$refs.agentTable.rowsSelected)) return false
      this.rowsSelected = _.cloneDeep(this.$refs.agentTable.rowsSelected)
      this.openCriticalityDialogVisible = true
    },
    openDetails () {
      if (_.isEmpty(this.$refs.agentTable.rowsSelected) || this.$refs.agentTable.rowsSelected.length > 1) {
        return false
      }
      this.agentSelected = _.cloneDeep(this.$refs.agentTable.rowsSelected[0])
      this.hideHostDetails = false
    },
    createCustomHostname (agentSelected) {
      this.$refs['renameHostRef'].validate(valid => {
        if (valid) {
          this.$store
            .dispatch(CUSTOM_HOSTNAME_REQ, {
              agentId: agentSelected.agentId,
              customHostname: agentSelected.customHostname,
              criticality: agentSelected.criticality
            })
            .then(
              () => {
                this.$refs.agentTable.rowsSelected[0].customHostname = agentSelected.customHostname
                this.openCustomHostnameDialogVisible = false
                this.$message({
                  type: 'success',
                  message: `Agent ${agentSelected.agentId} is now renamed to ${agentSelected.customHostname}.`
                })
              },
              errMsg => {
                // keep open & show error
                this.$message({
                  type: 'error',
                  message: errMsg || `Something went wrong.`
                })
                this.openCustomHostnameDialogVisible = true
              }
            )
        }
      })
    },
    decommissionHosts (agentsSelected) {
      this.$store
        .dispatch(DECOMMISSION_AGENTS_REQ, {
          agents: _.map(agentsSelected, 'agentId')
        })
        .then(
          () => {
            this.openDecommissionDialogVisible = false
            this.$message({
              type: 'success',
              message: `Agents were successfully committed for decommissioning.`
            })
            this.$refs.hostTableToolbar.refreshTable()
          },
          errMsg => {
            // keep open & show error
            this.$message({
              type: 'error',
              message: errMsg || `Something went wrong.`
            })
            this.decommissionHostsSelection.error = errMsg || `Something went wrong.`
            this.openDecommissionDialogVisible = true
          }
        )
    },
    setCriticalityLevel (rows, criticality) {
      rows.forEach(row => {
        row.criticality = criticality
      })

      this.$store.dispatch(BULK_HOSTNAME_REQ, rows).then(
        () => {
          this.$refs.agentTable.rowsSelected.forEach(row => {
            row.criticality = criticality
          })
          this.openCriticalityDialogVisible = false
          this.$message({
            type: 'success',
            message: `All hosts have been marked ${criticality}`
          })
        },
        errMsg => {
          // keep open & show error
          this.$message({
            type: 'error',
            message: errMsg || `Something went wrong.`
          })
          this.openCriticalityDialogVisible = true
        }
      )
    },
    updateTableQueryData () {
      if (this.$refs.agentTable) {
        this.$refs.agentTable.updateTableData()
      }
    },
    recordCountHandler () {
      // key is used to re-render TableToolbar component
      // on page change to update 'queryCountText'
      this.accountKeyActiveAgentList.key = !this.accountKeyActiveAgentList.key
      this.accountKeyActiveAgentList.reloadToolbar = false
    },
    modifyColumnsData (selectedColumns) {
      this.vmColumnPrefs.userId = this.userProfile.id
      this.vmColumnPrefs.tblName = this.tableName
      this.vmColumnPrefs.preferedCols = selectedColumns.length === 0 ? NaN : selectedColumns
      this.vmColumnPrefs.tblId = 1 // For Mapping with database tables

      this.visibleHostsColumns = this.accountKeyActiveAgentList.updateVisibleColumns(this.hostsColumns, selectedColumns)

      // store preferences in db
      this.$store.dispatch(SAVE_VM_VIEW_PREFERENCES, this.vmColumnPrefs).then(data => {
        // store preferences in vuex
        this.vmColumnPrefs.preferedCols = this.visibleHostsColumns
        this.$store.dispatch(PREFERENCE_STORE_REQ, this.vmColumnPrefs)
      })
    },
    getHostsByAccountKey (tableMetaData) {
      this.$store
        .dispatch(ACCOUNTKEY_AGENT_LIST_REQ, {
          accountKeys: [this.$route.query.accountKey]
        })
        .then(agents => {
          this.setTableMetaData(tableMetaData)
          this.apiCalled = true
        })
    },
    getHostsByListOfAccountKeys (tableMetaData) {
      this.$store
        .dispatch(ACCOUNTKEY_AGENT_LIST_REQ, {
          accountKeys: this.$route.query.accountKeys
        })
        .then(agents => {
          this.setTableMetaData(tableMetaData)
          this.apiCalled = true
        })
    },
    callApi (tableMetaData) {
      if (!this.$_.isEmpty(this.$route.query.accountKey)) {
        this.getHostsByAccountKey(tableMetaData)
      } else if (!this.$_.isEmpty(this.$route.query.accountKeys)) {
        this.getHostsByListOfAccountKeys(tableMetaData)
      } else {
        this.$store
          .dispatch(ACCOUNTKEY_AGENT_LIST_REQ, {
            accountKeys: []
          })
          .then(agents => {
            this.setTableMetaData(tableMetaData)
            this.apiCalled = true
          })
      }
    },
    setTableMetaData (tableMetaData) {
      this.accountKeyActiveAgentList.searchTags = tableMetaData.searchTags
      this.accountKeyActiveAgentList.currentPage = tableMetaData.activePage
    },
    refreshTableData (tableMetaData) {
      this.apiCalled = false
      this.displayTableActions = {
        show: false,
        singleSelect: false,
        multiselect: false,
        locationTagEnabled: false,
        decommissionEnabled: false
      }
      this.callApi(tableMetaData)
    },
    loadVMColumnPreferences () {
      // check if already present in store
      if (_.has(this.userPref, this.userProfile.id) && _.has(this.userPref[this.userProfile.id], this.tableName)) {
        //  read values from store
        this.visibleHostsColumns = this.userPref[this.userProfile.id][this.tableName]
        // this.updateStoreWithPrefs()
      } else {
        // fetch from database
        this.$store.dispatch(VM_VIEW_PREFERENCES_REQ, this.userProfile.id).then(data => {
          this.visibleHostsColumns = this.hostsColumns.filter(col => {
            return this.vmPreferences.includes(col.label)
          })
          this.updateStoreWithPrefs()
        })
      }
    },
    updateStoreWithPrefs () {
      this.vmColumnPrefs = {
        userId: this.userProfile.id,
        tblName: this.tableName,
        preferedCols: this.visibleHostsColumns
      }

      this.$store.dispatch(PREFERENCE_STORE_REQ, this.vmColumnPrefs)
    }
  },
  created () {
    this.changeFilterSelection = _.debounce((field, event) => {
      this.filterTableBy(field)
    }, 250)

    let tableMetaData = {
      activePage: 1,
      searchTags: []
    }
    if (!this.$_.isEmpty(this.$route.query.agentId)) {
      tableMetaData.searchTags.push(this.$route.query.agentId)
    }
    if (!this.$_.isEmpty(this.$route.query.status)) {
      tableMetaData.searchTags.push(this.$route.query.status)
    }
    if (!this.$_.isEmpty(this.$route.query.state)) {
      tableMetaData.searchTags.push(this.$route.query.state)
    }
    if (!this.$_.isEmpty(this.$route.query.upgradeable)) {
      tableMetaData.searchTags.push(this.$route.query.upgradeable)
    }
    this.callApi(tableMetaData)
    this.loadVMColumnPreferences()
  },
  computed: {
    ...mapGetters([
      'accountKeyAgentListReqStatus',
      'accountKeyActiveAgentSummary',
      'accountKeyActiveAgentList',
      'userProfile',
      'vmPreferences',
      'userPref'
    ]),
    hostStatusOptions () {
      return HostStatusEnum.properties
    },
    hostSensorOptions () {
      return OnOffEnum.properties
    },
    criticalityOptions () {
      return CriticalityLevelEnum
    },
    openPublicPorts () {
      let exposedList = []
      this.accountKeyActiveAgentSummary.exposedAgents.forEach(agent => {
        agent.agentDetails.openPortRanges.forEach(portrange => {
          exposedList.push({
            hostname: agent.customHostname,
            from: portrange.from,
            protocol: portrange.protocol,
            to: portrange.to
          })
        })
      })
      return exposedList
    }
  },
  components: {
    PageHeaders,
    TableToolbar,
    ExpandableMultiSelectTableElement,
    AsideSidebar,
    HostDetailsFeed
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/global_classes.css';
@import 'assets/styles/icon.css';
@import 'assets/styles/accounts_list.css';

.table-toolbar {
  .el-button:last-of-type {
    .c-icon {
      border-left: 1px solid var(--border-color);
      padding-left: 10px;
    }
  }
}

>>> .el-radio {
  margin: 10px;
  line-height: 20px;

  .el-radio__label {
    vertical-align: middle;

    i {
      vertical-align: middle;
    }
  }
}

.error {
  text-align: center;
  color: var(--text-color-danger);
}

.disabled {
  color: var(--tuna-400);
  cursor: not-allowed;
  .c-icon {
    color: var(--tuna-400);
  }
}

.el-button {
  background-color: var(--denim-600);
  color: white;
}

.search-reset {
  line-height: 36px;

  p {
    display: inline;
  }

  .icon-text-button {
    background: var(--denim-500);
    padding: 5px 10px;
    vertical-align: middle;

    span {
      color: white;
    }

    .c-icon {
      margin-right: 0px !important;
    }
  }

  .helper-message {
    background: var(--denim-50);
    padding: 20px;
  }
}

.filter-button-group {
  .el-button {
    background-color: white;
    color: var(--gray-800);
    margin-bottom: 25px;

    &.active {
      background-color: var(--denim-600);
      color: white;
    }
  }

  >>> .el-input {
    input {
      border-radius: 20px;
      width: 102px;
      height: 37px;
    }
  }
}

.localaction-button-group {
  .el-button {
    background-color: white;
  }
}

.text-btn {
  cursor: pointer;
  color: #1a90fa;
  font-size: 11px;
  font-weight: 600;
  text-decoration: none;
  display: inline-block;
}

.filter-input {
  display: table-cell;
}

>>> .search-box-container {
  position: relative;
  right: 8.5%;
}

.filter-name-validator {
  position: absolute;
  top: 34px;
  left: 3px;
  color: red;
  width: 110px;
}

.relative-pos {
  position: relative;
}

.absolute-pos {
  position: absolute;
}

.flex-dis {
  display: flex;
}

>>> .el-dialog__body {
  padding: 30px 70px;
}

>>> .el-dialog__header {
  padding: 20px 70px 10px;
}

>>> .el-dialog__footer {
  padding: 10px 113px 70px 106px;
}

.location-tag {
  height: 40px;
  min-width: 129px;
  margin: 0 14px 14px 0;
  border: 1px solid #297fca;
  border-radius: 4px;
  color: #297fca;
  background-color: #ffffff;
}

.location-tag-input {
  height: 40px;
  width: 127px;
  margin: 0 14px 12px 0;
  border: none;
  color: #297fca;
  background-color: #ffffff;
}

.active-tag {
  background-color: rgba(41, 127, 202, 0.2) !important;
}

.disabled-btn {
  opacity: 0.5;
  cursor: not-allowed;
}

.lift-up {
  position: relative;
  bottom: 8px;
}

.create-location-tag {
  margin-top: 32px;
  position: relative;
  left: 58%;
}

.empty-location-tag-container {
  display: flex;
  box-sizing: border-box;
  height: 264px;
  width: 449px;
  border: 1px solid #297fca;
  border-radius: 4px;
  background-color: #ffffff;
  justify-content: center;
  align-items: center;
}

.location-tags-container {
  display: flex;
  width: 449px;
  flex-wrap: wrap;
  max-height: 264px;
  overflow-y: auto;
}

.location-tag-warning-txt {
  padding-right: 17px;
  height: 48px;
  width: 380px;
  color: #297fca;
  font-family: Roboto;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: right;
}

.location-tag-footer-btn-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.location-tag-txt-btn {
  border: none;
  background: none;
  color: #1a90fa;
  margin-top: 4px;
}

.drop-down-title {
  font-size: 11px;
  color: #1a90fa;
  font-weight: 600;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/hosts/AccountKeyHosts.vue